export default "__VITE_ASSET__BoZLuX_h__"